import { render } from "./ResetWeakPassword.vue?vue&type=template&id=93988042&scoped=true"
import script from "./ResetWeakPassword.vue?vue&type=script&lang=js"
export * from "./ResetWeakPassword.vue?vue&type=script&lang=js"

import "./reset-password.scss?vue&type=style&index=0&id=93988042&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\hrportal\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93988042"]])

export default __exports__